import NewsItem from './NewsItem'

function NewsList(props){

     
    return(


        
      props.news.map((item) => { 
        return(
          <NewsItem
            key={item.title}
            title={item.title}
            picture={item.picture}
            text={item.text}
            date={item.date}
          />
        )       
      }) 

    )
}

export default NewsList;